import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
export type JobCardDataFragment = { __typename?: 'Job', key: string, title: string, sourceEmployerName: string, dateOnIndeed: number, viewJobLink?: string | null, sponsoredDisclaimer?: string | null, employer?: { __typename?: 'Employer', key: string, dossier?: { __typename?: 'EmployerDossier', images?: { __typename?: 'ImageBundle', squareLogoUrls?: { __typename?: 'SquareLogoUrlBundle', url256: string } | null } | null } | null } | null, source: { __typename?: 'JobSource', responsiveness?: { __typename?: 'JobSourceResponsiveness', averageResponseTimeDays?: number | null, responseRate?: number | null } | null }, tracking?: { __typename?: 'JobTrackingResult', jobClick: { __typename?: 'JobTrackingJobClickResult', url?: string | null } } | null, location: { __typename?: 'JobLocation', admin1Code?: string | null, city?: string | null, countryCode: string, postalCode?: string | null, formatted: { __typename?: 'FormattedJobLocation', short: string, long: string } }, compensation?: { __typename?: 'JobCompensation', formattedText?: string | null, currencyCode?: string | null, baseSalary?: { __typename?: 'Salary', unitOfWork?: Types.UnitOfWork | null, rangeMinor?: { __typename?: 'AtLeastMinor' } | { __typename?: 'AtMostMinor' } | { __typename?: 'ExactlyMinor', value: string } | { __typename?: 'RangeMinor', min: string } | null } | null } | null, attributes: Array<{ __typename?: 'JobAttribute', key: string, label: string }>, jobTypes: Array<{ __typename?: 'JobAttribute', key: string, label: string, sentiment?: Types.JobSeekerSentiment | null }>, shiftAndSchedule: Array<{ __typename?: 'JobAttribute', key: string, label: string, sentiment?: Types.JobSeekerSentiment | null }>, benefits: Array<{ __typename?: 'JobAttribute', key: string, label: string }>, indeedApply: { __typename?: 'JobIndeedApplyAttributes', scopes: Array<Types.JobIndeedApplyScope> }, hiringDemand?: { __typename?: 'HiringDemand', isUrgentHire: boolean, isHighVolumeHiring: boolean } | null, matchFactors: Array<{ __typename?: 'MatchFactor', key?: string | null, value?: string | null }>, jobseekerPreferences?: { __typename?: 'JobseekerPreferences', paySentiment?: Types.JobSeekerSentiment | null } | null, jobPackagingFeatures?: { __typename?: 'JobPackagingFeatures', brandedJobs: boolean, brandingReasons: Array<Types.FeaturedBrandingReason> } | null, commute?: { __typename?: 'JobCommute', durationMinutes: number } | null, featuredCardData?: { __typename?: 'FeaturedCardData', eligible: boolean, headerImageUrl?: string | null, enticerSignals: Array<{ __typename?: 'EnticerSignal', type: string, text: string }> } | null, interviewNowModel?: { __typename?: 'JobCardInterviewNowModel', interviewerCount?: number | null } | null, savedJob?: { __typename?: 'SavedJob', state: Types.SavedJobState, applicationDraft?: { __typename?: 'SavedJobApplicationDraft', expiryTime: number } | null } | null };

export type LoggedOutJobCardDataFragment = { __typename?: 'Job', key: string, title: string, sourceEmployerName: string, dateOnIndeed: number, viewJobLink?: string | null, sponsoredDisclaimer?: string | null, employer?: { __typename?: 'Employer', key: string, dossier?: { __typename?: 'EmployerDossier', images?: { __typename?: 'ImageBundle', squareLogoUrls?: { __typename?: 'SquareLogoUrlBundle', url256: string } | null } | null } | null } | null, source: { __typename?: 'JobSource', responsiveness?: { __typename?: 'JobSourceResponsiveness', averageResponseTimeDays?: number | null, responseRate?: number | null } | null }, tracking?: { __typename?: 'JobTrackingResult', jobClick: { __typename?: 'JobTrackingJobClickResult', url?: string | null } } | null, location: { __typename?: 'JobLocation', admin1Code?: string | null, city?: string | null, countryCode: string, postalCode?: string | null, formatted: { __typename?: 'FormattedJobLocation', short: string, long: string } }, compensation?: { __typename?: 'JobCompensation', formattedText?: string | null, currencyCode?: string | null, baseSalary?: { __typename?: 'Salary', unitOfWork?: Types.UnitOfWork | null, rangeMinor?: { __typename?: 'AtLeastMinor' } | { __typename?: 'AtMostMinor' } | { __typename?: 'ExactlyMinor', value: string } | { __typename?: 'RangeMinor', min: string } | null } | null } | null, attributes: Array<{ __typename?: 'JobAttribute', key: string, label: string }>, jobTypes: Array<{ __typename?: 'JobAttribute', key: string, label: string, sentiment?: Types.JobSeekerSentiment | null }>, shiftAndSchedule: Array<{ __typename?: 'JobAttribute', key: string, label: string, sentiment?: Types.JobSeekerSentiment | null }>, benefits: Array<{ __typename?: 'JobAttribute', key: string, label: string }>, indeedApply: { __typename?: 'JobIndeedApplyAttributes', scopes: Array<Types.JobIndeedApplyScope> }, hiringDemand?: { __typename?: 'HiringDemand', isUrgentHire: boolean, isHighVolumeHiring: boolean } | null, matchFactors: Array<{ __typename?: 'MatchFactor', key?: string | null, value?: string | null }>, jobseekerPreferences?: { __typename?: 'JobseekerPreferences', paySentiment?: Types.JobSeekerSentiment | null } | null, jobPackagingFeatures?: { __typename?: 'JobPackagingFeatures', brandedJobs: boolean, brandingReasons: Array<Types.FeaturedBrandingReason> } | null, commute?: { __typename?: 'JobCommute', durationMinutes: number } | null, featuredCardData?: { __typename?: 'FeaturedCardData', eligible: boolean, headerImageUrl?: string | null, enticerSignals: Array<{ __typename?: 'EnticerSignal', type: string, text: string }> } | null, interviewNowModel?: { __typename?: 'JobCardInterviewNowModel', interviewerCount?: number | null } | null };

export type LoggedInJobCardDataFragment = { __typename?: 'Job', savedJob?: { __typename?: 'SavedJob', state: Types.SavedJobState, applicationDraft?: { __typename?: 'SavedJobApplicationDraft', expiryTime: number } | null } | null };

export const LoggedOutJobCardDataFragmentDoc = gql`
    fragment loggedOutJobCardData on Job {
  key
  employer {
    key
    dossier {
      images {
        squareLogoUrls {
          url256
        }
      }
    }
  }
  source {
    responsiveness {
      averageResponseTimeDays
      responseRate
    }
  }
  tracking {
    jobClick {
      url
    }
  }
  location {
    formatted {
      short
      long
    }
    admin1Code
    city
    countryCode
    postalCode
  }
  title
  compensation {
    formattedText
    currencyCode
    baseSalary {
      unitOfWork
      rangeMinor {
        ... on RangeMinor {
          min
        }
        ... on ExactlyMinor {
          value
        }
      }
    }
  }
  attributes {
    key
    label
  }
  jobTypes: attributes(customClass: "BM62A") {
    key
    label
    sentiment
  }
  shiftAndSchedule: attributes(customClass: "BTSWR") {
    key
    label
    sentiment
  }
  benefits: attributes(customClass: "SXMYH") {
    key
    label
  }
  sourceEmployerName
  indeedApply {
    scopes
  }
  dateOnIndeed
  hiringDemand {
    isUrgentHire
    isHighVolumeHiring
  }
  matchFactors {
    key
    value
  }
  jobseekerPreferences {
    paySentiment
  }
  jobPackagingFeatures {
    brandedJobs
    brandingReasons
  }
  commute(from: $commuteFrom, method: $commuteMethod) @include(if: $includeCommute) {
    durationMinutes
  }
  viewJobLink @client
  featuredCardData @client {
    eligible
    headerImageUrl
    enticerSignals {
      type
      text
    }
  }
  interviewNowModel @client {
    interviewerCount
  }
  sponsoredDisclaimer @client
}
    `;
export const LoggedInJobCardDataFragmentDoc = gql`
    fragment loggedInJobCardData on Job {
  savedJob {
    state
    applicationDraft {
      expiryTime
    }
  }
}
    `;
export const JobCardDataFragmentDoc = gql`
    fragment jobCardData on Job {
  ...loggedOutJobCardData
  ...loggedInJobCardData
}
    ${LoggedOutJobCardDataFragmentDoc}
${LoggedInJobCardDataFragmentDoc}`;